var formatPhoneNumberIntl = require('react-phone-number-input').formatPhoneNumberIntl;
var parsePhoneNumberFromString = require('libphonenumber-js').parsePhoneNumberFromString;
export var parsePhone = function (value) {
    var parsedPhone;
    if (value.startsWith('8') &&
        value.replace(/\(|\)\s/, '').length === 11 &&
        parsePhoneNumberFromString(value, 'RU')) {
        parsedPhone = parsePhoneNumberFromString(value, 'RU').formatNational();
    }
    else if (value.startsWith('9') && parsePhoneNumberFromString(value, 'RU')) {
        parsedPhone = parsePhoneNumberFromString(value, 'RU').formatNational();
    }
    else {
        parsedPhone = formatPhoneNumberIntl(value) || formatPhoneNumberIntl("+".concat(value));
    }
    return parsedPhone;
};
export var isRusNumber = function (value) {
    return (value.startsWith('8') &&
        value.replace(/\(|\)\s/, '').length === 11 &&
        !!parsePhoneNumberFromString(value, 'RU')) ||
        (value.startsWith('9') && !!parsePhoneNumberFromString(value, 'RU'));
};
